import { Pipe, PipeTransform } from '@angular/core';
import { PipingObjectType } from 'src/app/shared/models/autogenerated-piping';
import { getPipingObjectTypeLabel } from '../consolidation-mapping-dictionary.model';

/** Maps a `PipingObjectType` enum value to its display label (Pipe/Valve) for the Consolidation Mapping grid. */
@Pipe({
    name: 'consolidationMappingPipingObjectType',
    standalone: false
})
export class ConsolidationMappingPipingObjectTypePipe implements PipeTransform {
  transform(value: PipingObjectType): string {
    return getPipingObjectTypeLabel(value);
  }
}
